<template>
  <div class="timeline">
    <div class="timeline-item">
      <div class="timeline-item_tail"></div>
      <div class="timeline-item_node"></div>
      <div class="timeline-item_wrapper">
        <div class="timeline-item_timestamp">{{ timestamp }}</div>
        <div class="timeline-item_content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Timeline',
    props: {
      timestamp: {
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>
.timeline-item{
  position: relative;
  padding-bottom: 20px;
  .timeline-item_tail{
    position: absolute;
    left: 4px;
    height: 100%;
    border-left: 2px solid #E4E7ED;
  }
  .timeline-item_node{
    left: -1px;
    width: 12px;
    height: 12px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E4E7ED;
    border-radius: 50%;
  }
  .timeline-item_wrapper{
    position: relative;
    padding-left: 28px;
    top: -3px;
    .timeline-item_timestamp{
      color: #909399;
      line-height: 1;
      font-size: 13px;
      margin-bottom: 8px;
      padding-top: 4px;
    }
    .timeline-item_content{
      color: #303133;
    }
  }
}
</style>
